import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [owner, setOwner] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gymOwner')); }
    catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem('gymToken') || null);
  const [loading, setLoading] = useState(true);

  // Verify stored token is still valid on mount
  useEffect(() => {
    const verify = async () => {
      if (token) {
        try {
          const res = await authAPI.getProfile();
          setOwner(res.data);
          localStorage.setItem('gymOwner', JSON.stringify(res.data));
        } catch {
          logout();
        }
      }
      setLoading(false);
    };
    verify();
  }, []); // eslint-disable-line

  const login = async (phone, password) => {
    const res = await authAPI.login({ phone, password });
    const { token: newToken, owner: newOwner } = res.data;
    localStorage.setItem('gymToken', newToken);
    localStorage.setItem('gymOwner', JSON.stringify(newOwner));
    setToken(newToken);
    setOwner(newOwner);
    return newOwner;
  };

  const logout = () => {
    localStorage.removeItem('gymToken');
    localStorage.removeItem('gymOwner');
    setToken(null);
    setOwner(null);
  };

  const refreshOwner = async () => {
    const res = await authAPI.getProfile();
    setOwner(res.data);
    localStorage.setItem('gymOwner', JSON.stringify(res.data));
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ owner, token, loading, login, logout, refreshOwner }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
